"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AndroidContainerUpdater = (function () {
    function AndroidContainerUpdater(window) {
        this.android = window.Android;
    }
    AndroidContainerUpdater.prototype.showUpdatePrompt = function () {
        return this.android.showUpdatePrompt();
    };
    return AndroidContainerUpdater;
}());
exports.AndroidContainerUpdater = AndroidContainerUpdater;
